import { Twitch } from "lucide-react";
import TwitchEmbed from "../components/TwitchEmbed";

export default function LiveStream() {
  return (
    <div data-testid="live-page" className="text-white">
      <section className="max-w-7xl mx-auto px-5 md:px-8 pt-16 md:pt-24">
        <div className="text-xs uppercase tracking-[0.35em] text-axe-tangerine font-bold">
          Live Now
        </div>
        <h1 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl">
          AXE <span className="text-axe-purple">Live Stream</span>
        </h1>
        <p className="mt-5 max-w-2xl text-neutral-400 text-base sm:text-lg">
          Tune in when we're scrimming, competing, or running community nights. Offline? Hit
          follow on Twitch and you'll ping every time we go live.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 mt-10">
        <TwitchEmbed channel="antixquade" height={600} />
        <div className="mt-6 flex flex-wrap items-center gap-4">
          <a
            href="https://www.twitch.tv/antixquade"
            target="_blank"
            rel="noreferrer"
            data-testid="live-follow-cta"
            className="inline-flex items-center gap-2 rounded-full bg-axe-purple px-7 py-3 text-xs uppercase tracking-[0.25em] font-bold text-white hover:bg-axe-purple-hover drop-shadow-[0_0_14px_rgba(176,38,255,0.45)]"
          >
            <Twitch size={14} /> Follow on Twitch
          </a>
          <a
            href="https://discord.gg/antixquade"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-axe-tangerine px-7 py-3 text-xs uppercase tracking-[0.25em] font-bold text-black hover:bg-axe-tangerine-hover"
          >
            Get Go-Live pings in Discord
          </a>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 mt-16">
        <div className="grid md:grid-cols-3 gap-5">
          {[
            { t: "Mon · Wed · Fri", l: "Team scrims", d: "8pm – 11pm local" },
            { t: "Tue · Thu", l: "Ranked grind + coaching VODs", d: "7pm onward" },
            { t: "Sat", l: "Community night — sub games & 1v1s", d: "6pm – late" },
          ].map((s) => (
            <div key={s.l} className="rounded-2xl border border-axe-border bg-axe-surface p-6">
              <div className="text-[10px] uppercase tracking-[0.3em] text-axe-purple font-bold">{s.t}</div>
              <div className="mt-2 font-display font-bold text-xl text-white">{s.l}</div>
              <div className="mt-1 text-sm text-neutral-400">{s.d}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
